import React, { useState } from 'react';
import ColorPanel from '../ColorPanel/ColorPanel';

import { useTheme } from '../../contexts/ThemeContext';
import { motion } from 'framer-motion';
import './Home.scss';
import Kaleidoscope from '../Canvas/Kaleidoscope';
import Bubbles from '../Canvas/Bubbles';
import Load from '../Canvas/Load';
export default function Home() {
    
    const darkTheme  = useTheme();
    const [canvasColors, setCanvasColors] = useState([])
    const [loading, setLoading] = useState(false)
    

    const getColor = (col) => {
        setCanvasColors(col)
    }

    const getLoad = (state) => {
        setLoading(state)
    }


    return (
        <motion.div
        initial={{opacity: 0}}
        animate={{opacity: 1}} 
        className={(darkTheme) ? "home-dark" : "home"}>
            <div className={(darkTheme) ? "main-dark" : "main"}>
                    <ColorPanel sendColor={getColor} getLoad={getLoad}/>
                {(!loading) ? <div className="canvas">
                    <Kaleidoscope colors={canvasColors} className="canvas-1"/>   
                    <Bubbles colors={canvasColors}/>
                </div> : <Load />}
                
            </div>
        </motion.div>
    )
}
